import { Card, Typography } from 'antd';
import React, { PropsWithChildren } from 'react';
import styled from 'styled-components';

type Props = PropsWithChildren & {
    readonly title: string;
    readonly isLoading?: boolean;
};

export const ChartWrapper = ({ title, isLoading, children }: Props) => {
    return (
        <StyledWrapper>
            <StyledCard loading={isLoading} type='inner'>
                <Typography.Text>{title}</Typography.Text>
                {children}
            </StyledCard>
        </StyledWrapper>
    );
};

const StyledWrapper = styled.div`
    flex: 1 0 49%;
    height: 100%;
`;

const StyledCard = styled(Card)`
    min-height: 256px;
    max-height: 256px;
    height: 100%;
`;
